export default "__VITE_ASSET__BEjNl7to__"